import { loader } from '../useStaffCard.utils/loader';
export const staffLiteCardLoader = (staffOrigin) => {
    if (!staffOrigin) {
        throw new Error('useStaffCard: поле "staffOrigin" обязательны для работы в B2B');
    }
    return loader(staffOrigin + '/m/staff-lite-card/build/index.js');
};
